<template>
  <section class="about-suggestion">
    <div class="about-suggestion__content">
      <ImgLazy
        :image-url="SuggestionHandImage"
        alt-text=""
        aspect-ratio="323 / 412"
        class="about-suggestion__title-image"
      />
      <h3 class="about-suggestion__title">こんな時におすすめ</h3>
      <div class="about-suggestion__cases">
        <div class="case-item">
          <p class="case-item__title mb-16">イベント時の景品や、お礼として</p>
          <p class="case-item__note mb-24">
            景品の持ち込み不要で幹事も参加者も楽々
          </p>
          <ImgLazy
            :image-url="Suggestion1Image"
            alt-text="イベント時の景品や、お礼として"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
        <div class="case-item">
          <p class="case-item__title mb-16">ファンとのコミュニケーションに</p>
          <p class="case-item__note mb-24">
            活動者のオリジナルギフトでファンも大満足
          </p>
          <ImgLazy
            :image-url="Suggestion2Image"
            alt-text="ファンとのコミュニケーションに"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
        <div class="case-item">
          <p class="case-item__title mb-16">退職や異動などのご挨拶に</p>
          <p class="case-item__note mb-24">直接会えない人にも渡せる</p>
          <ImgLazy
            :image-url="Suggestion3Image"
            alt-text="退職や異動などのご挨拶に"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
        <div class="case-item">
          <p class="case-item__title mb-16">引き出物や参列者へのプチギフトに</p>
          <p class="case-item__note mb-24">記念のウェディングフォトを添えて</p>
          <ImgLazy
            :image-url="Suggestion4Image"
            alt-text="引き出物や参列者へのプチギフトに"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
        <div class="case-item">
          <p class="case-item__title mb-16">出産祝いのお返しに</p>
          <p class="case-item__note mb-24">
            <span>お子様の写真で</span><span>健やかな成長のご報告</span>
          </p>
          <ImgLazy
            :image-url="Suggestion5Image"
            alt-text="出産祝いのお返しに"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
        <div class="case-item">
          <p class="case-item__title mb-16">季節のイベントに</p>
          <p class="case-item__note mb-24">
            <span>季節感を意識したギフトで</span><span>盛り上がる</span>
          </p>
          <ImgLazy
            :image-url="Suggestion6Image"
            alt-text="季節のイベントに"
            aspect-ratio="52 / 27"
            image-class="case-item__image"
          />
        </div>
      </div>
      <div class="about-suggestion__usecase-wrapper">
        <div class="about-suggestion__usecase">
          <h4 class="about-suggestion__usecase--title mb-36">
            <span>ご利用事例</span>
          </h4>
          <div class="usecase">
            <p class="usecase__title">
              <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
              <span>ビンゴ大会の景品準備が</span><span>とても楽になりました！</span>
            </p>
            <div class="usecase__description">
              <p class="usecase__description--content">
                毎年、職場の忘年会の幹事を担当しているのですが、ビンゴ大会の景品の準備が本当に大変でした。いろいろな金額・種類の景品を買いに複数のお店をハシゴしたり、当日会場への搬入も大人数の手が必要で…。
              </p>
              <p class="usecase__description--content">
                gifteeは1等に旅行券、2等に家電、参加賞にカフェチケット50枚分…と必要な商品を一度にまとめて購入することができたし、<b>オンラインギフトなので当選者には後日ギフトの受け取りURLをメールなどで送るだけ。当日手ぶらで帰ることができて良かった</b>とみんなからも好評でした！
              </p>
            </div>
            <ImgLazy
              :image-url="PersonAImage"
              alt-text="ユーザの画像"
              aspect-ratio="74 / 121"
              class="usecase__image"
            />
          </div>
          <div class="usecase">
            <p class="usecase__title">
              <!-- eslint-disable-next-line prettier/prettier 改行がない場合に空白が入らないよう1行にまとめる -->
              <span>会えない親族・友人への</span><span>結婚の内祝いに便利！</span>
            </p>
            <div class="usecase__description">
              <p class="usecase__description--content">
                結婚式を挙げる予定はなかったのですが、結婚を報告したい親族や友人たちはたくさんいました。直接会えない人も多いので悩みましたが、gifteeを使えば結婚報告のメッセージと共に、メールやLINEで内祝いが贈れる！と思いました。
              </p>
              <p class="usecase__description--content">
                カタログギフトの種類も豊富なので、何を贈るか悩むこともなかったし、<b>100名近くの方に贈りたい時も「まとめてオーダー」を利用すれば、gifteeから100個分のギフトURLがまとめて納品される</b>ので、何度も決済する手間も省けてとても助かりました。
              </p>
            </div>
            <ImgLazy
              :image-url="PersonBImage"
              alt-text="ユーザの画像"
              aspect-ratio="74 / 121"
              class="usecase__image"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'
import SuggestionHandImage from '../../../../../../images/bulk_personal_orders/about/suggestion_hand.png'
import Suggestion1Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion1.png'
import Suggestion2Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion2.png'
import Suggestion3Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion3.png'
import Suggestion4Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion4.png'
import Suggestion5Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion5.png'
import Suggestion6Image from '../../../../../../images/bulk_personal_orders/about/suggestions/suggestion6.png'
import PersonAImage from '../../../../../../images/bulk_personal_orders/about/person_a.png'
import PersonBImage from '../../../../../../images/bulk_personal_orders/about/person_b.png'
</script>

<style lang="scss" scoped>
.about-suggestion {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $primary-lighten;

  &__content {
    width: 100%;
    max-width: 1440px;
    padding: 130px 72px 96px;
    box-sizing: border-box;

    @media all and (max-width: ($pc-width - 1)) {
      padding: 64px 56px;
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      padding: 64px 24px;
    }
  }

  &__title {
    display: inline-block;
    color: $primary;
    font-weight: bold;
    font-size: 4.4rem;
    line-height: 1.6;
    position: relative;
    margin-bottom: 81px;

    @media all and (max-width: ($pc-width - 1)) {
      font-size: 2.8rem;
      margin-bottom: 48px;
    }

    &::after {
      content: '';
      display: inline-block;
      width: 107px;
      height: 137px;
      background-image: url('../../../../../../images/bulk_personal_orders/about/suggestion_hand.png');
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      position: absolute;
      top: -40px;
      // 画像の横幅(107px) + 余白(16px) 分 右に移動(x -1)
      right: calc((107px + 16px) * -1);

      @media all and (max-width: ($pc-width  - 1)) {
        display: none;
      }
    }
  }

  &__title-image {
    display: none;

    @media all and (max-width: ($pc-width  - 1)) {
      display: block;
      margin: 0 auto 8px;
      width: 65px;
      height: 83px;
      object-fit: contain;
    }
  }

  &__cases {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px;

    @media all and (max-width: ($pc-width  - 1)) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media all and (max-width: ($base-contents-width - 1)) {
      grid-template-columns: 1fr;
    }

    .case-item {
      padding: 32px 16px;
      box-sizing: border-box;
      border-radius: 32px;
      background-color: $white;

      &__title {
        color: $black;
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 1.6;
      }

      &__note {
        color: $gray-1;
        font-size: 1.4rem;
        line-height: 1.6;

        @media all and (max-width: ($pc-width  - 1)) {
          & > span {
            display: block;
          }
        }
      }

      &__image {
        width: 100%;
        object-fit: contain;
      }
    }
  }

  &__usecase-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__usecase {
    margin-top: 64px;
    max-width: 880px;
    width: 100%;

    @media all and (max-width: ($pc-width  - 1)) {
      margin-top: 48px;
      max-width: none;
    }

    &--title {
      color: $black;
      font-size: 2.5rem;
      font-weight: bold;
      line-height: 1;

      text-align: center;
      position: relative;

      @media all and (max-width: ($pc-width  - 1)) {
        font-size: 1.8rem;
      }

      &:after {
        content: '';
        width: 100%;
        height: 1px;
        display: block;
        background-color: $gray-1;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
      }

      & > span {
        display: inline-block;
        padding: 0 32px;
        background-color: $primary-lighten;
        position: relative;
        z-index: 1;
      }
    }

    .usecase {
      display: grid;
      grid-template-areas:
        'title image'
        'description image';
      grid-template-columns: 1fr min-content;
      grid-template-rows: min-content 1fr;
      padding: 32px;
      background-color: $white;
      box-sizing: border-box;
      border-radius: 32px;
      row-gap: 14px;
      column-gap: 24px;

      @media all and (max-width: ($pc-width  - 1)) {
        padding: 16px;
      }

      @media all and (max-width: ($base-contents-width  - 1)) {
        grid-template-areas:
          'title image'
          'description description';
        align-items: center;
        padding: 32px 16px;
      }

      &:last-child {
        margin-top: 44px;

        @media all and (max-width: ($base-contents-width  - 1)) {
          margin-top: 35px;
        }
      }

      &__title {
        grid-area: title;
        color: $primary;
        font-weight: bold;
        font-size: 1.8rem;
        line-height: 1.6;
        text-align: left;

        @media all and (max-width: ($base-contents-width  - 1)) {
          & > span {
            display: block;
          }
        }
      }

      &__description {
        grid-area: description;
        text-align: left;

        &--content {
          color: $black;
          font-size: 1.4rem;
          line-height: 1.6;

          & > b {
            color: $primary;
            font-weight: bold;
          }
        }
      }

      &__image {
        grid-area: image;
        width: 98px;
        object-fit: contain;

        @media all and (max-width: ($base-contents-width  - 1)) {
          width: 56px;
        }
      }
    }
  }
}
</style>
